import List from "./list/LabelReportList";

export default { List };
